import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Modal from "react-bootstrap/Modal";
import { storeUser } from "../util/http";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import Footer from "./Footer";
import Nav from "./Nav";

function EarlyAdopter() {
  // Success modal style tokens (use Bootstrap + existing brand variables; avoid hard-coded new palette values)
  const BRAND_RED = "var(--color-wine-red)";
  const BODY_TEXT = "var(--bs-body-color)";
  const MUTED_TEXT = "var(--bs-secondary-color)";
  const COUPON_HIGHLIGHT_BG = "rgba(153, 0, 51, 0.08)"; // subtle brand tint
  const DIVIDER_COLOR = "rgba(0, 0, 0, 0.10)";
  const SUCCESS_ICON_STROKE = "var(--bs-success)";
  const SUCCESS_ICON_BG = "rgba(var(--bs-success-rgb), 0.10)";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [userInfo, setUserInfo] = useState({
    fullname: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    role: "",
    restaurant: "",
  });

  // For button hover effect
  const [isHovered, setIsHovered] = useState(false);

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setUserInfo((prevState) => ({ ...prevState, [name]: value }));
  }

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function handleSubmit(e) {
    e.preventDefault();
    let validationErrors = {};

    if (userInfo.email.length === 0 || !isValidEmail(userInfo.email)) {
      validationErrors.email = "Email is invalid.";
    }
    if (userInfo.fullname.length === 0) {
      validationErrors.fullname = "Please enter a name.";
    }
    if (userInfo.city.length === 0) {
      validationErrors.city = "Please enter a city.";
    }
    if (userInfo.state.length === 0) {
      validationErrors.state = "Please choose a state.";
    }
    if (userInfo.zip.length === 0) {
      validationErrors.zip = "Please enter a zip code.";
    }
    if (userInfo.role.length === 0) {
      validationErrors.role = "Please choose a role.";
    }
    if (userInfo.restaurant.length === 0) {
      validationErrors.restaurant = "What is the name of your restaurant?";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        await storeUser({ ...userInfo, source: "earlyadopter" });
        handleShow();
        setUserInfo({
          fullname: "",
          email: "",
          city: "",
          state: "",
          zip: "",
          role: "",
          restaurant: "",
        });
      } catch (error) {
        console.log("🚀 ~ handleSubmit ~ error:", error.message);
      }
      setErrors({});
    }
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Early Adopter Program | Restaurant Menu Training Platform</title>
        <meta name="description" content="Join the Early Adopter Program for Speak Your Menu, the restaurant menu training platform for front of house staff, restaurant owners, and managers. Get early access to mobile menu training and menu education tools." />
        {/* Open Graph */}
        <meta property="og:title" content="Early Adopter Program | Restaurant Menu Training Platform" />
        <meta property="og:description" content="Join the Early Adopter Program for Speak Your Menu, the restaurant menu training platform for front of house staff, restaurant owners, and managers. Get early access to mobile menu training and menu education tools." />
        <meta property="og:type" content="website" />
  <meta property="og:url" content="https://speakyourmenu.com/earlyadopter" />
  <meta property="og:image" content="https://speakyourmenu.com/SpeakYourMenu_Logo.png" />
        <meta property="og:site_name" content="Speak Your Menu" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Early Adopter Program | Restaurant Menu Training Platform" />
        <meta name="twitter:description" content="Join the Early Adopter Program for Speak Your Menu, the restaurant menu training platform for front of house staff, restaurant owners, and managers. Get early access to mobile menu training and menu education tools." />
  <meta name="twitter:image" content="https://speakyourmenu.com/SpeakYourMenu_Logo.png" />
        <meta name="twitter:site" content="@speakyourmenu" />
        {/* Canonical URL */}
  <link rel="canonical" href="https://speakyourmenu.com/earlyadopter" />
        {/* BreadcrumbList JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": "https://speakyourmenu.com/"},
            {"@type": "ListItem", "position": 2, "name": "Early Adopter", "item": "https://speakyourmenu.com/earlyadopter"}
          ]
        })}</script>
        {/* To update keywords or URLs, edit above meta tags and JSON-LD. */}
      </Helmet>
      <Nav />
      <main id="main-content" tabIndex="-1">
        <section className="my-4">
          <div className="container py-5">
            <div className="p-5 lc-block">
              <div className="lc-block mb-3 text-center">
                <h1 className="fw-bold display-4 mb-3 text-secondary" >
                  Sign up here to get Early Adopter's gift.
                </h1>
                <h2 className="fw-bold display-6 text-center mb-4" style={{ color: "var(--color-wine-red)" }}>
                  🎁 3 months Full Access ! 🎁
                </h2>
                <h2 className="fw-bold display-6 text-center mb-4 text-secondary" >
                  Sign up now and get rewarded for commiting to your team's success.
                </h2>
              </div>
            </div>
            <div className="p-5 lc-block shadow rounded-3 col-xl-10 offset-xl-1">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4" controlId="exampleForm.ControlInput1">
                  <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullname"
                    placeholder="Jan Smith"
                    value={userInfo.fullname}
                    autoFocus
                    onChange={handleChange}
                    className="form-control-lg"
                  />
                  {errors.fullname && (
                    <div className="text-danger small mt-1">{errors.fullname}</div>
                  )}
                </Form.Group>
                <Form.Group className="mb-4" controlId="exampleForm.ControlInput2">
                  <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="name@example.com"
                    value={userInfo.email}
                    onChange={handleChange}
                    className="form-control-lg"
                  />
                  {errors.email && (
                    <div className="text-danger small mt-1">{errors.email}</div>
                  )}
                </Form.Group>
                <Row className="mb-4">
                  <Form.Group as={Col} controlId="formGridCity">
                    <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={userInfo.city}
                      onChange={handleChange}
                      className="form-control-lg"
                    />
                    {errors.city && (
                      <div className="text-danger small mt-1">{errors.city}</div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridState">
                    <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>State</Form.Label>
                    <Form.Select
                      size=""
                      defaultValue="Choose..."
                      name="state"
                      value={userInfo.state}
                      onChange={handleChange}
                      className="form-control-lg"
                    >
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District Of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </Form.Select>
                    {errors.state && (
                      <div className="text-danger small mt-1">{errors.state}</div>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} controlId="formGridZip">
                    <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>Zip</Form.Label>
                    <Form.Control
                      type="text"
                      name="zip"
                      value={userInfo.zip}
                      onChange={handleChange}
                      className="form-control-lg"
                    />
                    {errors.zip && (
                      <div className="text-danger small mt-1">{errors.zip}</div>
                    )}
                  </Form.Group>
                </Row>
                <fieldset>
                  <Form.Group
                    as={Row}
                    name="role"
                    className="mb-4"
                    onChange={handleChange}
                  >
                    <Form.Label as="legend" column sm={4} className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>
                      What's your role?
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Check
                        type="radio"
                        label="Restaurant Owner"
                        value="Restaurant Owner"
                        onChange={handleChange}
                        checked={userInfo.role === "Restaurant Owner"}
                        name="role"
                        id="formHorizontalRadios1"
                      />
                      <Form.Check
                        type="radio"
                        label="Restaurant Manager"
                        value="Restaurant Manager"
                        onChange={handleChange}
                        checked={userInfo.role === "Restaurant Manager"}
                        name="role"
                        id="formHorizontalRadios2"
                      />
                      <Form.Check
                        type="radio"
                        label="Restaurant Employee"
                        value="Restaurant Employee"
                        onChange={handleChange}
                        checked={userInfo.role === "Restaurant Employee"}
                        name="role"
                        id="formHorizontalRadios3"
                      />
                    </Col>
                    {errors.role && (
                      <div className="text-danger small mt-1">{errors.role}</div>
                    )}
                  </Form.Group>
                </fieldset>
                <Form.Group className="mb-4" controlId="exampleForm.ControlTextarea1">
                  <Form.Label className="fw-semibold mb-1" style={{ color: "var(--color-wine-red)" }}>Restaurant Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="restaurant"
                    placeholder="Il Pastifico e Vino"
                    rows={3}
                    value={userInfo.restaurant}
                    onChange={handleChange}
                    className="form-control-lg"
                  />
                  {errors.restaurant && (
                    <div className="text-danger small mt-1">{errors.restaurant}</div>
                  )}
                </Form.Group>
                <div className="text-center">
                  <Button
                    className="btn-lg px-5"
                    type="submit"
                    style={{
                      background: isHovered ? "var(--color-wine-sparkling)" : "var(--color-wine-red)",
                      color: isHovered ? "#222" : "var(--color-wine-white)",
                      border: isHovered ? "2px solid var(--color-wine-red)" : "none",
                      boxShadow: isHovered
                        ? "0 0 0 0.2rem rgba(255,221,0,0.25)"
                        : "0 2px 8px rgba(153,0,51,0.10)",
                      fontWeight: 700,
                      letterSpacing: "0.5px",
                      transition: "background 0.18s, color 0.18s, border 0.18s, box-shadow 0.18s"
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </section>
        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          aria-labelledby="early-adopter-success-title"
        >
          <Modal.Header closeButton>
            <div className="d-flex align-items-center gap-2">
              <span
                aria-hidden="true"
                style={{
                  width: 20,
                  height: 20,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 999,
                  background: SUCCESS_ICON_BG,
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  style={{ display: "block" }}
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    stroke={SUCCESS_ICON_STROKE}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <Modal.Title
                id="early-adopter-success-title"
                style={{ color: BRAND_RED, fontSize: 21, fontWeight: 700 }}
              >
                You’re in. Here’s what happens next.
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body style={{ color: BODY_TEXT, lineHeight: 1.55, fontSize: 15, padding: "20px 24px" }}>
            <p style={{ marginBottom: 16, color: MUTED_TEXT }}>
              Thanks for signing up for Speak Your Menu.
            </p>
            <p style={{ marginBottom: 16 }}>
              We’ve received your information and will follow up shortly to help you explore how Speak Your Menu works for your restaurant.
            </p>

            <hr style={{ margin: "16px 0", borderColor: DIVIDER_COLOR, opacity: 1 }} />

            <p style={{ marginBottom: 0 }}>
              You’ll also receive a confirmation email that includes your{" "}
              <span
                style={{
                  display: "inline-block",
                  fontWeight: 700,
                  background: COUPON_HIGHLIGHT_BG,
                  padding: "2px 4px",
                  borderRadius: 6,
                }}
              >
                3-month free access coupon
              </span>
              , along with next steps and helpful context to see if this is a good fit.
            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center" style={{ paddingTop: 20 }}>
            <Button onClick={handleClose} style={{ minHeight: 44, paddingLeft: 22, paddingRight: 22 }}>
              Got it
            </Button>
          </Modal.Footer>
        </Modal>
      </main>
      <Footer />
    </div>
  );
}

export default EarlyAdopter;
